module.exports = __webpack_public_path__ + "static/media/plan_name.d5dd46f7.svg";